module.exports = __webpack_public_path__ + "static/24-deeb5d1e322f7360d0eccf058641e209.jpg";